import { OrderState } from "@app/store/order.slice";
import { OrderEvent } from "@app/domain";

/**
 * `id`/`source` are only real (sourced from the API) when populated by the
 * initial track response (see `order.slice.ts`'s `fetchTrackOrder.fulfilled`).
 * The `isEventNeedUpdate`-triggered refetch (`OrderAPI.getEvents`) hits an
 * endpoint whose response genuinely has no `id`/`source` fields — for those,
 * a stable synthetic id and a "system" fallback source are used rather than
 * inventing data the endpoint doesn't provide.
 */
export function toOrderEvents(events: OrderState["events"]): OrderEvent[] {
  return events.map((event, index) => ({
    id: event.id ?? `${event.createdAt}-${index}`,
    orderStatusDescription: event.orderStatusDescription,
    occurredAt: event.createdAt,
    source: event.source ?? "system",
  }));
}
